import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import {
  LayoutDashboard, Upload, FileText, Users, User, Crosshair,
  LogOut, Menu, X, Activity, Sparkles, Sun, Moon
} from 'lucide-react';
import './Layout.css';

const NAV = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/upload', icon: Upload, label: 'Upload Match' },
  { to: '/reports', icon: FileText, label: 'Match Reports' },
  { to: '/team-analysis', icon: Users, label: 'Teams' },
  { to: '/player-analysis', icon: User, label: 'Players' },
  { to: '/opposition-scouting', icon: Crosshair, label: 'Scouting' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="app-shell">
      <header className="topnav">
        <div className="topnav__brand">
          <div className="topnav__logo"><Activity size={18} /></div>
          <div className="topnav__brand-text">
            <span className="topnav__name">MatchMind <span className="topnav__name-accent">AI</span></span>
            <span className="topnav__tagline">Tactical Intelligence</span>
          </div>
        </div>

        <nav className="topnav__links">
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `topnav__link ${isActive ? 'topnav__link--active' : ''}`}
            >
              <Icon size={15} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="topnav__right">
          <div className="topnav__status">
            <Sparkles size={12} />
            <span>AI online</span>
          </div>
          <button
            className="topnav__icon-btn"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label="Toggle color theme"
          >
            {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <button className="topnav__user" onClick={handleLogout} title="Logout">
            <div className="topnav__user-avatar">{user?.avatar || user?.name?.[0] || 'U'}</div>
            <span className="topnav__user-name">{user?.name}</span>
            <LogOut size={13} />
          </button>
          <button className="topnav__menu" onClick={() => setMobileOpen(o => !o)}>
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </header>

      {mobileOpen && (
        <nav className="topnav__mobile">
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setMobileOpen(false)}
              className={({ isActive }) => `topnav__mobile-link ${isActive ? 'topnav__mobile-link--active' : ''}`}
            >
              <Icon size={17} /><span>{label}</span>
            </NavLink>
          ))}
          <button className="topnav__mobile-link" onClick={handleLogout}>
            <LogOut size={17} /><span>Logout</span>
          </button>
        </nav>
      )}

      <main className="app-shell__content">
        <Outlet />
      </main>
    </div>
  );
}
